import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { keyframes } from 'styled-components'

import { flex } from '../../constants/style'
import { pages } from '../../constants/site'

import Button, { MenuButton } from '../UI/Button'
import { Column, Row } from '../UI/Grid'

import Logo from '../Logo'

import StickyHeader from '../StickyHeader'

import BackgroundImage from '../../../static/assets/images/__background.jpg'

import { scrollTo } from '../../utils'

const HeroWrapper = Column.extend`
  height: 100vh;
  max-height: 1080px;
  min-height: 600px;
  position: relative;
  margin-bottom: 120px;
`

const Background = Column.extend`
  background-image: url("${BackgroundImage}");
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  height: 100%;
  width: 100%;
`

const Header = Row.extend`
  color: white;
  padding: 2rem;
  position: absolute;
  width: 100%;
`

const LogoWrapper = Column.extend`
  margin-bottom: 40px;
`

const Footer = Column.extend`
  color: white;
  padding: 1rem;
`

const bouncing = keyframes`
  0%, 100% {
    transform: translate3d(0, 0, 0);
  }

  50% {
    transform: translate3d(0, 2px, 0);
  }
`

const ScrollDown = Column.extend`
  cursor: pointer;
  user-select: none;

  /* div {
    will-change: transform;
    animation: ${bouncing} .8s linear infinite;
  } */
  svg {
    margin-top: 8px;
  }
`

class Hero extends Component {
  hero = {
    component: null,
    height: 0,
  }

  componentDidMount() {
    this.getHeroHeight()
  }

  getHero = ref => (this.hero.component = ref)

  getHeroHeight = () => {
    this.hero.height = this.hero.component.offsetHeight
  }

  scrollDown = () => {
    scrollTo(this.hero.height, null, 700)
  }

  render() {
    const { onMenuClick, onCalendarClick } = this.props

    return (
      <HeroWrapper innerRef={this.getHero}>
        <Header align={flex.align.CENTER} justify={flex.justify.END}>
          <MenuButton onClick={onMenuClick} />
        </Header>
        <Background>
          <Column align={flex.align.CENTER} justify={flex.justify.CENTER}>
            <LogoWrapper
              align={flex.align.CENTER}
              grow={0}
              justify={flex.justify.CENTER}
            >
              <Logo />
            </LogoWrapper>
            <a href={pages.BIGLIETTERIA.link}>
              <Button>BIGLIETTERIA</Button>
            </a>
            <Button style={{ marginTop: '2em' }} onClick={onCalendarClick}>
              CALENDARIO
            </Button>
          </Column>
          <Footer
            grow={0}
            align={flex.align.CENTER}
            justify={flex.justify.CENTER}
          >
            <ScrollDown
              onClick={this.scrollDown}
              grow={0}
              align={flex.align.CENTER}
              justify={flex.justify.CENTER}
            >
              Scroll Down
              <div>
                <svg width="37" height="18" viewBox="0 0 37 18" fill="none">
                  <path
                    d="M1 1L18.027 16L36 1"
                    stroke="white"
                    strokeWidth="2"
                  />
                </svg>
              </div>
            </ScrollDown>
          </Footer>
        </Background>
        <StickyHeader onMenuClick={onMenuClick} />
      </HeroWrapper>
    )
  }
}

Hero.defaultProps = {
  onMenuClick: () => {},
}

Hero.propTypes = {
  onMenuClick: PropTypes.func,
}

export default Hero



// WEBPACK FOOTER //
// ./src/components/Hero/index.js